export default {
  Admin: "admin",
  GFCF: "GFCF Approver",
  GPM: "GPM Approver",
  GCAD: "GCAD Approver",
  BusinnessOwner: "Business Owner",
  EnagaementLead: "Engagement Lead",
  BusinessAnalyst: "Business Analyst",
};
